import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Home } from 'lucide-react';
import { animations } from '../animations';
import PhoneInput from 'react-phone-input-2';
import PlaceInput from '../../VehicleType/PlaceInput';
import { 
  Header,
  Body,
  FormGroup,
  Label,
  Error,
  ButtonGroup,
  Button 
} from '../StyledComponents';

export const HomeCareLocationStep = ({
  phone,
  phoneError,
  onPhoneChange,
  onLocationChange,
  onNext,
  isLoading,
  selectedLocation,
  locationError
}) => {
  return (
    <motion.div {...animations.pageTransition}>
      <Header>
        <Home />
        <h2>Home Care Location</h2>
        <p style={{ margin: '0.5rem 0 0', fontSize: '0.9rem', color: '#64748b' }}>
          Professional healthcare services delivered to your doorstep
        </p>
      </Header>
      <Body>
        <FormGroup>
          <Label>Phone Number</Label>
          <PhoneInput
            country="et"
            value={phone}
            onChange={onPhoneChange}
            enableAreaCodes={true}
            containerClass="phone-input-container"
            placeholder="Enter your phone number"
            inputStyle={{
              width: '100%',
              padding: '14px 50px',
              fontSize: '16px',
              border: '1px solid #d1d5db',
              borderRadius: '8px'
            }}
          />
          {phoneError && <Error>{phoneError}</Error>}
        </FormGroup>

        <FormGroup>
          <Label>Service Location</Label>
          <div style={{
            background: 'white',
            borderRadius: '0.75rem',
            padding: '1.5rem',
            border: '1px solid #e2e8f0',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
          }}>
            <Label style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>
              Enter the service address
            </Label>
            <PlaceInput
              value={selectedLocation}
              onChanges={onLocationChange}
              error={locationError}
              disabled={isLoading}
            />
            <small style={{ color: '#6b7280', fontSize: '0.8rem', marginTop: '0.5rem', display: 'block' }}>
              Start typing the address where home care service is needed
            </small>
          </div>
        </FormGroup>

        <div style={{
          background: '#f0f9ff',
          border: '1px solid #bfdbfe',
          borderRadius: '8px',
          padding: '1rem',
          marginBottom: '2rem'
        }}>
          <p style={{ margin: 0, color: '#1e40af', fontSize: '0.9rem' }}>
            <strong>Professional Home Care Services Include:</strong><br />
            • General health consultations<br />
            • Nursing care and medical monitoring<br />
            • Wound care and dressing changes<br />
            • Medication administration<br />
            • Post-operative care
          </p>
        </div>

        <ButtonGroup>
          <Button variant="secondary" disabled>
            Previous
          </Button>
          <Button
            variant="primary"
            onClick={onNext}
            disabled={!selectedLocation || isLoading || !phone}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            style={{ 
              background: '#16a34a',
              color: 'white'
            }}
          >
            Continue to Services
          </Button>
        </ButtonGroup>
      </Body>
    </motion.div>
  );
};


